import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import LoginTemplate from "modules/login/LoginTemplate";
import * as AuthApi from "services/http/auth";
import { PAGES } from "utils/links";

import styles from "./style.module.scss";

const AcceptInvitationPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const [tokenValid, setTokenValid] = useState<boolean | null>(null);

  useEffect(() => {
    if (!token) {
      navigate(PAGES.LOGIN, { replace: true });
      return;
    }

    AuthApi.verifyInvitationToken(token)
      .then(() => {
        navigate(`${PAGES.SET_NEW_PASSWORD}?token=${token}`, { replace: true });
      })
      .catch(() => setTokenValid(false));
  }, [token, navigate]);

  if (tokenValid === null) {
    return (
      <LoginTemplate title="Invitation" description="Verifying your invitation link...">
        <div className={styles.loading}>Loading...</div>
      </LoginTemplate>
    );
  }

  return (
    <LoginTemplate
      title="Link expired"
      description={
        "The invitation link is invalid or has\n expired. Please contact the\n administrator for a new invitation"
      }
    >
      <></>
    </LoginTemplate>
  );
};

export default AcceptInvitationPage;
